import type { ComponentProps } from "react"
import type { VariantProps } from "class-variance-authority"
import { SelectTrigger as SelectTriggerBase } from "@/v2-ui/select/base/SelectBase"
import { selectTriggerVariants } from "./select.constants"

export type SelectTriggerProps = ComponentProps<typeof SelectTriggerBase> &
  VariantProps<typeof selectTriggerVariants>

function SelectTrigger(props: SelectTriggerProps) {
  const { className, size, variant, ...selectTriggerBaseProps } = props
  return (
    <SelectTriggerBase
      className={selectTriggerVariants({ size, variant, className })}
      {...selectTriggerBaseProps}
    />
  )
}

export default SelectTrigger
